module.exports = __webpack_public_path__ + "img/purple-circle-table-2.f700daa3.png";